// Keep in sync with packages/firebase/functions/src/functions/company.ts.
// The server (Cloud Function + security rules) is the source of truth; these
// helpers exist so the UI can validate a Company URL before writing and give
// the user immediate feedback instead of a silent revert.

// Top-level Next.js routes that must never be claimed as a company slug,
// otherwise the URL would collide with an app page under /[companySlug].
export const RESERVED_SLUGS = [
  'admin',
  'api',
  'app',
  'login',
  'logout',
  'generators',
  'integration',
  'forgot-password',
  'unverified-user',
  'forbidden',
  'error',
  '404',
];

const SLUG_PATTERN = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/;

export const slugify = (title: string) =>
  title
    .toLowerCase()
    .replace(/ß/g, 'ss')
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/[\W_]+/g, '-')
    .replace(/^-|-$/g, '');

export const isReservedSlug = (slug: string) => RESERVED_SLUGS.includes(slug);

export const isValidSlugFormat = (slug: string) =>
  typeof slug === 'string' &&
  slug.length >= 2 &&
  slug.length <= 80 &&
  SLUG_PATTERN.test(slug);

export const isValidSlug = (slug: string) =>
  isValidSlugFormat(slug) && !isReservedSlug(slug);
